import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import WidgetCard from "./WidgetCard";
import { Col, Row, Select } from "antd";
import { AggregationField, ICtrTrendOverTimeProps, IPerformanceComparisonData } from "@/ts/common-types";

const { Option } = Select;

interface IPerformanceComparisonWidgetProps
    extends Omit<ICtrTrendOverTimeProps, "widgetData"> {
    widgetData: IPerformanceComparisonData[];
}

const PerformanceComparisonWidget: React.FC<IPerformanceComparisonWidgetProps> = ({ widgetData, additionalTitleComponent, filterPillsComponent }) => {

  const metricOptions = [AggregationField.IMPRESSION, AggregationField.CTR, AggregationField.ROAS, AggregationField.CONVERSION_RATE];

  const [xAxisMetric, setXAxisMetric] = useState(AggregationField.IMPRESSION);
  const [yAxisMetric, setYAxisMetric] = useState(AggregationField.CTR);

  const chartOptions = {
      chart: { type: "scatter" },
      title: { text: "" },
      xAxis: {
          title: {
              text: `${
                  xAxisMetric.charAt(0).toUpperCase() + xAxisMetric.slice(1)
              }`,
          },
      },
      yAxis: {
          title: {
              text: `${
                  yAxisMetric.charAt(0).toUpperCase() + yAxisMetric.slice(1)
              }`,
          },
      },
      tooltip: {
        formatter: function (this: Highcharts.TooltipFormatterContextObject): string {
            return `
                <b>${xAxisMetric.charAt(0).toUpperCase() + xAxisMetric.slice(1)}:</b> ${this.x}<br/>
                <b>${yAxisMetric.charAt(0).toUpperCase() + yAxisMetric.slice(1)}:</b> ${this.y}
            `;
        },
    },
      series: [
          {
              name: "Product Data",
              data: widgetData.map((item) => [
                  item[xAxisMetric as keyof IPerformanceComparisonData],
                  item[yAxisMetric as keyof IPerformanceComparisonData],
              ]),
              color: "#007BFF",
          },
      ],
  };

  return (
      <WidgetCard className="my-4">
          <Row className="fs-5 w-100" justify="space-between">
              <Col span={16}>
                  <h5>Performance Comparison</h5>
              </Col>
              {additionalTitleComponent && (
                  <Col span={1}>{additionalTitleComponent()}</Col>
              )}
          </Row>
          <Row className="p-2" gutter={16} justify="center" align="middle">
              <Col span={10}>
                  <Select
                      value={xAxisMetric}
                      onChange={(value) => setXAxisMetric(value)}
                      className="w-100"
                  >
                      {metricOptions.map((metric) => (
                          <Option key={metric} value={metric}>
                              {metric.charAt(0).toUpperCase() + metric.slice(1)}
                          </Option>
                      ))}
                  </Select>
              </Col>
              <Col span={2} className="text-center font-weight-bold">
                  Vs
              </Col>
              <Col span={10}>
                  <Select
                      value={yAxisMetric}
                      onChange={(value) => setYAxisMetric(value)}
                      className="w-100"
                  >
                      {metricOptions.map((metric) => (
                          <Option key={metric} value={metric}>
                              {metric.charAt(0).toUpperCase() + metric.slice(1)}
                          </Option>
                      ))}
                  </Select>
              </Col>
          </Row>
          {filterPillsComponent && (
              <Row>
                  <Col span={24}>{filterPillsComponent()}</Col>
              </Row>
          )}
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </WidgetCard>
  );
};

export default PerformanceComparisonWidget;
